type ActionType = {
  type:
    | "LOAD_STATE"
    | "SET_FIRST_NAME"
    | "SET_LAST_NAME"
    | "SET_EMAIL"
    | "SET_CLIENT"
    | "SET_ACCOUNT_TYPE"
    | "SET_ACQUISITION_DATE"
    | "SET_CONVERSION_DATE"
    | "SET_OWNER"
    | "SET_DAILY_REPORT"
    | "SET_PRODUCT_ID"
    | "RESET_STATE"
    | "SET_ACTIVE"
    | "SET_SUBSCRIPTIONS"
    | "SET_PRODUCT_CODE"
    | "SET_PERMISSIONS";
  value: any;
};

export type ManageAccountStateType = {
  owner: string | null;
  firstName: string | null;
  lastName: string | null;
  creationTime: number | null;
  level: string | null;
  active: boolean | null;
  levelUpdate: number | null;
  id: number | null;
  email: string | null;
  group: string | null;
  productId: number | null;
  dailyReport: "DISABLED" | "V1" | "V2" | "V1V2";
  subscriptions: any;
  permissions: string[];
  productCode:
    | "STANDARD"
    | "PREMIUM"
    | "ADVANCED"
    | "SYSTEMATIC_ENGINE"
    | "SYSTEMATIC_ENGINE_AND_PREMIUM"
    | "RISE"
    | "DISPERSION"
    | null;
};

export const initManageAccountState = {
  owner: null,
  firstName: null,
  lastName: null,
  creationTime: new Date().getTime(),
  level: null,
  active: null,
  levelUpdate: null,
  id: null,
  email: null,
  group: null,
  productId: null,
  dailyReport: "DISABLED",
  subscriptions: null,
  productCode: null,
  permissions: [],
};
export const manageAccountReducer = (
  draft: ManageAccountStateType,
  action: ActionType
) => {
  switch (action.type) {
    case "LOAD_STATE":
      draft.owner = action.value.owner;
      draft.firstName = action.value.firstName;
      draft.lastName = action.value.lastName;
      draft.creationTime = action.value.creationTime;
      draft.level = action.value.level;
      draft.active = action.value.active;
      draft.levelUpdate = action.value.levelUpdate;
      draft.id = action.value.id;
      draft.email = action.value.email;
      draft.group = action.value.group;
      draft.productId = action.value.productId;
      draft.productCode = action.value.product.productCode;
      draft.dailyReport = translateDailyReport(action.value);
      break;
    case "RESET_STATE":
      draft.owner = null;
      draft.firstName = null;
      draft.lastName = null;
      draft.creationTime = new Date().getTime();
      draft.level = null;
      draft.active = false;
      draft.levelUpdate = null;
      draft.id = null;
      draft.email = null;
      draft.group = null;
      draft.productId = null;
      draft.dailyReport = "DISABLED";
      break;
    case "SET_FIRST_NAME":
      draft.firstName = action.value;
      break;
    case "SET_LAST_NAME":
      draft.lastName = action.value;
      break;
    case "SET_OWNER":
      draft.owner = action.value;
      break;
    case "SET_ACQUISITION_DATE":
      draft.creationTime = action.value;
      break;
    case "SET_EMAIL":
      draft.email = action.value;
      break;
    case "SET_CLIENT":
      draft.group = action.value;
      break;
    case "SET_ACCOUNT_TYPE":
      draft.level = action.value;
      break;
    case "SET_CONVERSION_DATE":
      draft.levelUpdate = action.value;
      break;
    case "SET_DAILY_REPORT":
      draft.dailyReport = action.value;
      break;
    case "SET_PRODUCT_ID":
      draft.productId = action.value;
      break;
    case "SET_ACTIVE":
      draft.active = action.value;
      break;
    case "SET_SUBSCRIPTIONS":
      draft.subscriptions = action.value;
      break;
    case "SET_PRODUCT_CODE":
      draft.productCode = action.value;
      break;
    case "SET_PERMISSIONS":
      draft.permissions = action.value;
  }
};

const translateDailyReport = (accountData: any) => {
  if (accountData.emailSubscription && !accountData.emailSubscriptionV2) {
    return "V1";
  } else if (
    !accountData.emailSubscription &&
    accountData.emailSubscriptionV2
  ) {
    return "V2";
  } else if (
    !accountData.emailSubscription &&
    !accountData.emailSubscriptionV2
  ) {
    return "DISABLED";
  } else {
    return "V1V2";
  }
};
